import { ACTION_LABEL } from '../constants'
import { describeAuditChanges, formatHistoryDate } from '../utils/historyHelpers'
import { useAppSelector } from '../../../store/hooks'
import { historySelector } from '../../../store/slices/history'

export function useHistoryAuditTab() {
    const audit = useAppSelector(historySelector.audit)
    const auditLoading = useAppSelector(historySelector.auditLoading)
    const auditError = useAppSelector(historySelector.auditError)

    return {
        audit,
        auditLoading,
        auditError,
        actionLabel: ACTION_LABEL,
        formatDate: formatHistoryDate,
        describeChanges: describeAuditChanges,
    }
}
